// extracted by mini-css-extract-plugin
export default {"wrapper":"ToastLinkCopied_wrapper__SzYRZ","disabled":"ToastLinkCopied_disabled__GeGBi","content":"ToastLinkCopied_content__NwQNh"};